// @flow
import { APICore } from './apiCore';

const api = new APICore();

function ApiGetAllRekap(params: any): any {
    const baseUrl = '/api/admin/rekapitulasi/all';
    return api.get(`${baseUrl}`, params);
}

export { ApiGetAllRekap };
